export default __webpack_public_path__ + "static/media/1.be797b27.png";